export enum DatetimeComparison {
  is = 0,
  isBefore = 1,
  isAfter = 2,
  isUpdated = 3,
  was = 4,
  wasNot = 5,
  isWithin = 6,
  isBlank = 7,
  isPresent = 8,
}